export { default as ReportsGateway } from './ReportsGateway'
export { default as ReportsService } from './ReportsService'
export { default as ReportsServiceProvider } from './ReportsServiceProvider'



// WEBPACK FOOTER //
// ./src/api/reports/index.js